import React, { Component } from "react";
import LayoutWrapper from "./LayoutWrapper";
import { Switch, DatePicker, Select, Button } from "antd";
import AppTable from "../../partials/AppTable";
import "./maintenancequeue/maintenancequeue.scss";
import "./dashboard/dashboard.scss";
import AddNewIssueModal from "./AddNewIssueModal";
import issuecategoryapi from "../../../api/devapis/issuecategoryapi";
import mastercategoryapi from "../../../api/devapis/mastercategoryapi";

const { RangePicker } = DatePicker;
const { Option } = Select;

export const ISSUE_STATUS = {
  OPEN: 'OPEN',
  INPROGRESS: 'INPROGRESS',
  CANCELLED: 'CANCELLED',
  RESOLVED: 'RESOLVED',
  ONHOLD: 'ONHOLD',
  CLOSED: 'CLOSED',
};

export const ISSUE_STATUS_LABELS = {
  [ISSUE_STATUS.OPEN]: 'Open',
  [ISSUE_STATUS.INPROGRESS]: 'In Progress',
  [ISSUE_STATUS.CANCELLED]: 'Cancelled',
  [ISSUE_STATUS.RESOLVED]: 'Resolved',
  [ISSUE_STATUS.ONHOLD]: 'On Hold',
  [ISSUE_STATUS.CLOSED]: 'Closed',
};

class SchoolInfraMaintenanceTracker extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("SchoolInfraMaintenanceTracker");
    this.state = {
      onlySlaBreached: false,
      isAddModalVisible: false,
      issueList: [],
      loading: false,
      categories: [],
      loadingCategories: false,
      priorities: [],
      loadingPriorities: false,
      selectedCategory: undefined,
      selectedPriority: undefined,
      selectedStatus: undefined,
      selectedDateRange: null,
      total: 0,
      page: 1,
      limit: 10,
      kpiData: null,
    };
  }

  componentDidMount() {
    this.fetchIssueList();
    this.fetchCategories();
    this.fetchPriorities();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.store?.school_id !== this.props.store?.school_id) {
      this.fetchIssueList();
    }
  }

  fetchPriorities = () => {
    this.setState({ loadingPriorities: true });
    
    let token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith('bearer ')) {
        token = `Bearer ${token}`;
      }
    }

    const apiCall = this.props.api?.apiGetIssuePriorities || window.app?.props?.api?.apiGetIssuePriorities;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ priorities: res.data, loadingPriorities: false });
        } else {
          this.setState({ loadingPriorities: false });
        }
      })
      .catch((err) => {
        console.warn('Failed to load priorities:', err);
        this.setState({ loadingPriorities: false });
      });
  };

  fetchCategories = () => {
    this.setState({ loadingCategories: true });

    const processCategories = (res) => {
      let rawList = [];
      if (res && res.data) {
        if (Array.isArray(res.data)) rawList = res.data;
        else if (Array.isArray(res.data.data)) rawList = res.data.data;
        else if (Array.isArray(res.data.records)) rawList = res.data.records;
        else if (Array.isArray(res.data.categories)) rawList = res.data.categories;
        else if (Array.isArray(res.data.issueCategories)) rawList = res.data.issueCategories;
      } else if (Array.isArray(res)) {
        rawList = res;
      } else if (res && typeof res === 'object') {
        if (Array.isArray(res.records)) rawList = res.records;
        else if (Array.isArray(res.categories)) rawList = res.categories;
        else if (Array.isArray(res.data)) rawList = res.data;
      }

      if (rawList && rawList.length > 0) {
        const formatted = rawList
          .filter((item) => item && item.isActive !== false && item.active !== false)
          .map((item, idx) => ({
            issueCategoryId: item.issueCategoryId || item._id || item.id || `cat_${idx}`,
            name: item.name || item.category_name || item.categoryName || item.title || 'Category',
          }));

        this.setState({ categories: formatted, loadingCategories: false });
        return true;
      }
      this.setState({ loadingCategories: false });
      return false;
    };

    const apiCall =
      this.props.api?.apiGetIssueCategories ||
      this.api?.apiGetIssueCategories ||
      window.app?.props?.api?.apiGetIssueCategories;

    const masterCatApi =
      this.props.api?.apiGetMasterCategory ||
      this.api?.apiGetMasterCategory ||
      window.app?.props?.api?.apiGetMasterCategory;

    const tryIssueApi = () => {
      if (apiCall) {
        return apiCall({})
          .then((res) => {
            const success = processCategories(res);
            if (!success) tryMasterCatApi();
          })
          .catch(() => tryMasterCatApi());
      } else {
        tryMasterCatApi();
      }
    };

    const tryMasterCatApi = () => {
      if (masterCatApi) {
        return masterCatApi({})
          .then((res) => {
            const success = processCategories(res);
            if (!success) this.fetchCategoriesDirectly(processCategories);
          })
          .catch(() => this.fetchCategoriesDirectly(processCategories));
      } else {
        this.fetchCategoriesDirectly(processCategories);
      }
    };

    tryIssueApi();
  };

  fetchCategoriesDirectly = (processCategories) => {
    let token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth') ||
      '';
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith('bearer ')) {
        token = `Bearer ${token}`;
      }
    }
    const apiCall = this.props.api?.apiGetIssueCategories || window.app?.props?.api?.apiGetIssueCategories;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        const success = processCategories(res);
        if (!success) {
          this.setState({ loadingCategories: false });
        }
      })
      .catch(() => {
          this.setState({ loadingCategories: false });
      });
  };

  parseIssueRecords = (res) => {
    let records = [];
    let total = 0;

    if (!res) return { records: [], total: 0 };

    const rawData = res.data !== undefined ? res.data : res;

    if (Array.isArray(rawData)) {
      if (
        rawData.length > 0 &&
        rawData[0] &&
        typeof rawData[0] === "object" &&
        (Array.isArray(rawData[0].records) || Array.isArray(rawData[0].pagination))
      ) {
        records = Array.isArray(rawData[0].records) ? rawData[0].records : [];
        total = rawData[0].pagination?.[0]?.totalRecords ?? records.length;
      } else {
        records = rawData;
        total = res.total ?? res.totalCount ?? records.length;
      }
    } else if (rawData && typeof rawData === "object") {
      if (Array.isArray(rawData.records)) {
        records = rawData.records;
        total = rawData.totalCount ?? rawData.total ?? records.length;
      } else if (Array.isArray(rawData.data)) {
        records = rawData.data;
        total = rawData.totalCount ?? rawData.total ?? records.length;
      } else if (Array.isArray(rawData.issues)) {
        records = rawData.issues;
        total = rawData.total ?? records.length;
      } else if (Array.isArray(rawData.list)) {
        records = rawData.list;
        total = rawData.total ?? records.length;
      } else if (Array.isArray(rawData.result)) {
        records = rawData.result;
        total = rawData.total ?? records.length;
      }
    }

    const validRecords = (records || []).filter(
      (item) =>
        item &&
        typeof item === "object" &&
        Object.keys(item).length > 0 &&
        (item._id ||
          item.issueId ||
          item.issue_number ||
          item.id ||
          item.title ||
          item.category ||
          item.category_name ||
          item.categoryName ||
          item.issueCategoryData ||
          item.priority ||
          item.status ||
          item.description ||
          item.issue_name)
    );

    return {
      records: validRecords,
      total: total || validRecords.length,
    };
  };

  formatDateToYYYYMMDD = (d) => {
    if (!d) return "";
    if (typeof d.format === 'function') {
      return d.format('YYYY-MM-DD');
    }
    const date = new Date(d);
    if (isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  fetchIssueList = () => {
    this.fetchIssueKpis();
    const apiCall = this.props.api?.apiGetEducatorIssueList || this.api?.apiGetEducatorIssueList;
    if (apiCall) {
      this.setState({ loading: true });
      const schoolId = this.props.store?.school_id || localStorage.getItem("school_id") || "";
      const searchObj = {
        assignedSchools: schoolId ? [schoolId] : []
      };

      if (this.state.selectedCategory) {
        searchObj.categoryId = this.state.selectedCategory;
      }
      if (this.state.selectedPriority) {
        searchObj.priorityId = this.state.selectedPriority;
      }
      if (this.state.selectedStatus) {
        searchObj.status = this.state.selectedStatus;
      }
      if (this.state.selectedDateRange && this.state.selectedDateRange.length === 2) {
        const [start, end] = this.state.selectedDateRange;
        if (start) {
          searchObj.raisedOnStartDate = this.formatDateToYYYYMMDD(start);
        }
        if (end) {
          searchObj.raisedOnEndDate = this.formatDateToYYYYMMDD(end);
        }
      }
      if (this.state.onlySlaBreached) {
        searchObj.showOnlySLABreached = true;
      }

      const payload = {
        limit: this.state.limit || 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: this.state.page || 1,
        search: searchObj
      };

      console.log("apiGetEducatorIssueList payload:", payload);

      apiCall(payload)
        .then((res) => {
          this.setState({ loading: false });
          console.log("apiGetEducatorIssueList response:", res);
          const { records, total } = this.parseIssueRecords(res);
          this.setState({
            issueList: records,
            total: total,
          });
        })
        .catch((err) => {
          this.setState({ loading: false, issueList: [], total: 0 });
          console.error("Error fetching issue list:", err);
        });
    } else {
      console.warn("apiGetEducatorIssueList is not available on this.props.api or this.api");
    }
  };

  fetchIssueKpis = () => {
    const schoolId = this.props.store?.school_id || localStorage.getItem("school_id") || "";
    let payload = {};
    if (this.state.role === "SCHOOL_COORDINATOR" && schoolId) {
      payload.schoolId = schoolId;
    } else if (schoolId) {
      payload.schoolId = schoolId;
    }
    
    const apiCall = this.props.api?.apiGetIssueKpis || window.app?.props?.api?.apiGetIssueKpis;
    if (!apiCall) return;

    apiCall(payload)
      .then(res => {
        if (res && res.data && res.data[0]) {
          this.setState({ kpiData: res.data[0] });
        }
      })
      .catch(err => console.error("Failed to fetch KPIs:", err));
  };

  getColumns() {
    return [
      {
        dataIndex: "issueId",
        title: "Issue #",
        sorter: false,
        render: (text, record, index) => {
          const page = this.state.page || 1;
          const limit = this.state.limit || 10;
          const num = (page - 1) * limit + index + 1;
          return record.issueId && record.issueId.match(/^SIM-/) ? record.issueId : `SIM-${String(num).padStart(3, '0')}`;
        }
      },
      {
        dataIndex: "category",
        title: "Category",
        sorter: false,
        render: (text, record) => record.issueCategoryData?.name || record.category || text || "-"
      },
      {
        dataIndex: "priority",
        title: "Priority",
        sorter: false,
        render: (text, record) => {
          const val = record.issuePriorityData?.name || record.priority || text || "-";
          return <span className={`priority-text ${(val || '').toLowerCase()}`}>{val}</span>;
        }
      },
      {
        dataIndex: "status",
        title: "Status",
        sorter: false,
        render: (text, record) => {
          const rawStatus = String(record.status || text || '').toUpperCase().replace(/[\s-_]/g, '');
          let matchedKey = Object.keys(ISSUE_STATUS).find(
            (k) => ISSUE_STATUS[k].replace(/[\s-_]/g, '') === rawStatus
          );
          if (!matchedKey && rawStatus === 'CANCEL') matchedKey = 'CANCELLED';
          const statusValue = matchedKey ? ISSUE_STATUS[matchedKey] : (record.status || text);
          const displayLabel = (statusValue && ISSUE_STATUS_LABELS[statusValue]) || (record.status || text) || '-';
          const statusClass = (statusValue || record.status || text || '').toLowerCase().replace(/[\s-_]/g, '');

          return (
            <div className="d-flex align-items-center gap-2">
              <span className={`badge-pill status-${statusClass}`}>{displayLabel}</span>
              {(record.slaBreached || record.sla) && <span className="badge-pill alert-sla"><i className="la la-warning"></i> SLA</span>}
            </div>
          );
        }
      },
      {
        dataIndex: "raisedOn",
        title: "Raised On",
        sorter: false,
        render: (text, record) => {
          const dateStr = record.createdAt || record.raisedOn || text;
          if (!dateStr) return "-";
          const date = new Date(dateStr);
          if (isNaN(date.getTime())) return dateStr;

          const day = String(date.getDate()).padStart(2, '0');
          const month = date.toLocaleString('en-GB', { month: 'short' });
          const year = date.getFullYear();
          const time = date.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true }).toLowerCase();

          return `${day} ${month} ${year}, ${time}`;
        }
      },
      {
        dataIndex: "ageing",
        title: "Ageing",
        sorter: false,
        render: (text, record) => {
          const val = record.ageing !== undefined ? record.ageing : text;
          return (val !== undefined && val !== null && val !== "-") ? `${val} day${val === 1 || val === 0 ? '' : 's'}` : "-";
        }
      }
    ];
  }

  renderCards() {
    const { kpiData } = this.state;
    
    let openCount = 0;
    let inProgressCount = 0;
    let resolvedClosedCount = 0;
    let onHoldCount = 0;
    let slaBreachedCount = 0;

    if (kpiData) {
      slaBreachedCount = kpiData.slaBreachedCount || (kpiData.slaBreachedPipeline && kpiData.slaBreachedPipeline[0]?.slaBreached) || 0;
      
      if (kpiData.statusData && Array.isArray(kpiData.statusData)) {
        kpiData.statusData.forEach(item => {
          const status = String(item._id || "").toUpperCase().replace(/[\s-_]/g, '');
          const count = item.count || 0;
          if (status === 'OPEN') openCount += count;
          else if (status.includes('PROGRESS')) inProgressCount += count;
          else if (status.includes('HOLD')) onHoldCount += count;
          else if (status.includes('RESOLV') || status.includes('CLOSE')) resolvedClosedCount += count;
        });
      }
    }

    const formatCount = (num) => String(num).padStart(2, '0');

    const cards = [
      { count: formatCount(openCount), label: "Total Open" },
      { count: formatCount(inProgressCount), label: "In Progress" },
      { count: formatCount(resolvedClosedCount), label: "Resolved/ Closed" },
      { count: formatCount(onHoldCount), label: "On Hold" },
      { count: formatCount(slaBreachedCount), label: "Breaching Response Window" }
    ];

    return (
      <div className="row g-3 mb-4">
        {cards.map((card, i) => (
          <div className="col-12 col-sm-6 col-md" key={i}>
            <div className="orange-card">
              <div className="icon-wrapper">
                <i className="la la-graduation-cap"></i>
              </div>
              <div className="info-wrapper">
                <h3>{card.count}</h3>
                <p>{card.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderSearch() {
    return (
      <div className="search-card mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-3">
            <span className="filter-label">Category</span>
            <Select
              placeholder="Select"
              style={{ width: '100%' }}
              loading={this.state.loadingCategories}
              value={this.state.selectedCategory}
              onChange={(val) => this.setState({ selectedCategory: val, page: 1 }, this.fetchIssueList)}
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {this.state.categories.map((cat) => (
                <Option key={cat.issueCategoryId} value={cat.issueCategoryId}>
                  {cat.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-2">
            <span className="filter-label">Priority</span>
            <Select
              placeholder="Select"
              style={{ width: '100%' }}
              value={this.state.selectedPriority}
              onChange={(val) => this.setState({ selectedPriority: val, page: 1 }, this.fetchIssueList)}
              allowClear
              loading={this.state.loadingPriorities}
              showSearch
              optionFilterProp="children"
            >
              {this.state.priorities.map((p) => (
                <Option key={p.issuePriorityId} value={p.issuePriorityId}>
                  {p.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-2">
            <span className="filter-label">Status</span>
            <Select
              placeholder="Select"
              style={{ width: '100%' }}
              value={this.state.selectedStatus}
              onChange={(val) => this.setState({ selectedStatus: val, page: 1 }, this.fetchIssueList)}
              allowClear
            >
              {Object.keys(ISSUE_STATUS).map((key) => (
                <Option key={ISSUE_STATUS[key]} value={ISSUE_STATUS[key]}>
                  {ISSUE_STATUS_LABELS[ISSUE_STATUS[key]] || ISSUE_STATUS[key]}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-3">
            <span className="filter-label">Raised On</span>
            <RangePicker
              style={{ width: '100%' }}
              placeholder={["Select Start Date", "Select End Date"]}
              value={this.state.selectedDateRange}
              onChange={(val) => this.setState({ selectedDateRange: val, page: 1 }, this.fetchIssueList)}
            />
          </div>
          <div className="col-md-2">
            <button
              className="btn w-100 fw-bold d-flex align-items-center justify-content-center"
              style={{ backgroundColor: '#fca000', color: '#fff', height: '32px' }}
              onClick={this.fetchIssueList}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const headerRight = (
      <div className="d-flex align-items-center gap-4">
        <div className="d-flex align-items-center gap-2">
          <Switch
            checked={this.state.onlySlaBreached}
            onChange={(val) => this.setState({ onlySlaBreached: val, page: 1 }, this.fetchIssueList)}
            style={{ backgroundColor: this.state.onlySlaBreached ? '#fca000' : undefined }}
          />
          <span className="fw-bold" style={{ fontSize: '14px' }}>Show Only SLA Breached Issues</span>
        </div>
        <button
          className="btn fw-bold px-4 d-flex align-items-center gap-2"
          style={{ backgroundColor: '#fca000', color: '#fff', border: 'none', borderRadius: '20px' }}
          onClick={() => this.setState({ isAddModalVisible: true })}
        >
          <i className="la la-plus"></i> Add Issue
        </button>
      </div>
    );

    const rawList = Array.isArray(this.state.issueList) ? this.state.issueList : [];
    let validList = rawList.filter(
      (issue) =>
        issue &&
        typeof issue === "object" &&
        Object.keys(issue).length > 0 &&
        (issue._id ||
          issue.issueId ||
          issue.issue_number ||
          issue.id ||
          issue.title ||
          issue.category ||
          issue.category_name ||
          issue.categoryName ||
          issue.issueCategoryData ||
          issue.priority ||
          issue.status ||
          issue.description ||
          issue.issue_name)
    );

    if (this.state.onlySlaBreached) {
      validList = validList.filter((item) => item.showOnlySLABreached || item.is_sla_breached || item.sla);
    }

    if (this.state.selectedCategory) {
      const selCat = this.state.categories.find((c) => c.issueCategoryId === this.state.selectedCategory);
      const catName = selCat ? selCat.name.toLowerCase() : '';
      validList = validList.filter((item) => {
        const itemCatId = item.issueCategoryId || item.issue_category_id || item.categoryId || item.issueCategoryData?._id;
        const itemCatName = (item.issueCategoryData?.name || item.issueCategoryData?.categoryName || item.categoryName || item.category_name || item.category || '').toLowerCase();
        return (itemCatId && itemCatId === this.state.selectedCategory) || (catName && itemCatName.includes(catName));
      });
    }

    if (this.state.selectedPriority) {
      const selPriority = this.state.priorities.find((p) => p.issuePriorityId === this.state.selectedPriority);
      const prioName = selPriority ? selPriority.name.toLowerCase() : '';
      validList = validList.filter((item) => {
        const itemPrioId = item.issuePriorityData?._id || item.priorityId;
        const itemPrioName = (item.issuePriorityData?.name || item.priority || '').toLowerCase();
        return (itemPrioId && itemPrioId === this.state.selectedPriority) || (prioName && itemPrioName === prioName);
      });
    }

    if (this.state.selectedStatus) {
      const selectedNorm = String(this.state.selectedStatus || '').toUpperCase().replace(/[\s-_]/g, '');
      validList = validList.filter((item) => {
        const itemStatusNorm = String(item.status || '').toUpperCase().replace(/[\s-_]/g, '');
        if (selectedNorm === 'CANCELLED' && itemStatusNorm === 'CANCEL') return true;
        return itemStatusNorm === selectedNorm;
      });
    }

    if (this.state.selectedDateRange && this.state.selectedDateRange.length === 2) {
      const [start, end] = this.state.selectedDateRange;
      if (start && end) {
        const startTime = new Date(start).setHours(0, 0, 0, 0);
        const endTime = new Date(end).setHours(23, 59, 59, 999);
        validList = validList.filter((item) => {
          const itemDate = new Date(item.createdAt || item.created_at || item.raisedOn).getTime();
          return isNaN(itemDate) || (itemDate >= startTime && itemDate <= endTime);
        });
      }
    }

    const data = validList.map((issue, index) => ({
      issueId: issue.issueId || issue.issue_number || issue._id || issue.id,
      issueNumber: index + 1,
      category:
        issue.issueCategoryData?.name ||
        issue.issueCategoryData?.categoryName ||
        issue.issueCategoryData?.category_name ||
        issue.categoryName ||
        issue.category_name ||
        (issue.category_id && (issue.category_id.name || issue.category_id.category_name)) ||
        issue.category ||
        "-",
      priority: issue.issuePriorityData?.name || issue.priority || "-",
      status: issue.status || "-",
      raisedOn:
        issue.raisedOn ||
        (issue.createdAt
          ? new Date(issue.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })
          : issue.created_at || "-"),
      ageing:
        issue.ageing !== undefined && issue.ageing !== null
          ? `${issue.ageing} day`
          : (issue.createdAt
            ? `${Math.max(
              0,
              Math.floor((new Date() - new Date(issue.createdAt)) / (1000 * 60 * 60 * 24))
            )} day`
            : "-"),
      sla: issue.slaBreached || issue.showOnlySLABreached || issue.is_sla_breached || issue.sla || false,
      _id: issue._id || issue.issueId || issue.issue_number || issue.id,
    }));

    return (
      <LayoutWrapper title="School Infra Maintenance Issues Tracker" headerRight={headerRight}>
        <div className="dashboard-reporting mt-4">
          {this.renderCards()}
        </div>
        <div className="maintenance-queue mt-4">
          {this.renderSearch()}
          <div className="table-card">
            <div className="table-responsive">
              {!!data.length && (
                <AppTable
                  data={data}
                  columns={this.getColumns()}
                  total={this.state.total || data.length}
                  loading={this.state.loading}
                  onChange={(pagination) => {
                    this.setState({
                      page: pagination.current,
                      limit: pagination.pageSize
                    }, this.fetchIssueList);
                  }}

                  reorder={true}
                  targetType="tap"
                  isCustomRowKey={true}
                  customRowKey="_id"
                  isresponsive={true}
                  editable={true}
                  deletable={false}
                  viewable={true}
                  editAction={(record) => window.navigate(`/schoolinframaintenancetracker/editmaintenancequeue?id=${record.issueId}&mode=edit`)}
                  viewAction={(record) => window.navigate(`/schoolinframaintenancetracker/editmaintenancequeue?id=${record.issueId}&mode=view`)}
                />
              )}
              {data.length === 0 && <div className="empty_layout"></div>}
            </div>
          </div>
        </div>

        <AddNewIssueModal
          visible={this.state.isAddModalVisible}
          onCancel={() => this.setState({ isAddModalVisible: false })}
          onSuccess={() => {
            this.setState({ isAddModalVisible: false });
            this.fetchIssueList();
          }}
          api={this.props.api}
          store={this.props.store}
        />
      </LayoutWrapper>
    );
  }
}

export default connect(SchoolInfraMaintenanceTracker);
